<template>
<div class="chapter">
<div class="inner_page">
<div class="line"><span><img alt="img" src="images/line.png" width="100%"/></span></div>
<div class="fm-title"><span><b>CONTENTS</b></span></div>
<div class="line1"><span><img alt="img" src="images/line.png" width="100%"/></span></div>
<div class="toc1"><span><a href="#/foreword#fm1" id="fm-1">Foreword by William H. Goetzmann</a></span></div>
<div class="toc"><span><a href="#/acknowledgment#fm2" id="fm-2">Acknowledgments</a></span></div>
<div class="toc"><span><a href="#/introduction#fm3" id="fm-3">Introduction</a></span></div>
<div class="toc"><span><a href="#/ch01#ch1" id="ch-1">1. Roots</a></span></div>
<div class="toc"><span><a href="#/ch02#ch2" id="ch-2">2. Launching a Career</a></span></div>
<div class="toc"><span><a href="#/ch03#ch3" id="ch-3">3. Taming the Wilderness—Roads</a></span></div>
<div class="toc"><span><span href="#/ch04#ch4" id="ch-4" title="Link target outside of Sample">4. Taming the Wilderness—Dams</span></span></div>
<div class="toc"><span><span href="#/ch05#ch5" id="ch-5" title="Link target outside of Sample">5. Patriot in Pinstripes—Shipbuilding</span></span></div>
<div class="toc"><span><span href="#/ch06#ch6" id="ch-6" title="Link target outside of Sample">6. Man of Steel</span></span></div>
<div class="toc"><span><span href="#/ch07#ch7" id="ch-7" title="Link target outside of Sample">7. Creating an Image</span></span></div>
<div class="toc"><span><span href="#/ch08#ch8" id="ch-8" title="Link target outside of Sample">8. Planning for a Postwar World</span></span></div>
<div class="toc"><span><span href="#/ch09#ch9" id="ch-9" title="Link target outside of Sample">9. Debacle in Detroit</span></span></div>
<div class="toc"><span><span href="#/ch10#ch10" id="ch-10" title="Link target outside of Sample">10. Venturing Abroad</span></span></div>
<div class="toc"><span><span href="#/ch11#ch11" id="ch-11" title="Link target outside of Sample">11. Cargo Planes and Government Investigations</span></span></div>
<div class="toc"><span><span href="#/ch12#ch12" id="ch-12" title="Link target outside of Sample">12. Light Metals—Heavy Profits</span></span></div>
<div class="toc"><span><span href="#/ch13#ch13" id="ch-13" title="Link target outside of Sample">13. Kaiser and the Doctors</span></span></div>
<div class="toc"><span><span href="#/ch14#ch14" id="ch-14" title="Link target outside of Sample">14. Boss</span></span></div>
<div class="toc"><span><span href="#/ch15#ch15" id="ch-15" title="Link target outside of Sample">15. Global Development and a Pacific Paradise</span></span></div>
<div class="toc"><span><span href="#/ch16#ch16" id="ch-16" title="Link target outside of Sample">16. The Sunset Years</span></span></div>
<div class="toc"><span><span href="#/conclusion#bm1" id="bm-1" title="Link target outside of Sample">Conclusion</span></span></div>
<div class="toc"><span><span href="#/notes#bm2" id="bm-2" title="Link target outside of Sample">Notes</span></span></div>
<div class="toc"><span><span href="#/bibliography#bm3" id="bm-3" title="Link target outside of Sample">Bibliographic Note</span></span></div>
<div class="toc"><span><span href="#/index#bm4" id="bm-4" title="Link target outside of Sample">Index</span></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1ef4baca